import { attributes } from '../../core/ids-attributes';
import { customElement, scss } from '../../core/ids-decorators';
import IdsElement from '../../core/ids-element';
import styles from './ids-scroll-container.scss';

/**
 * IDS Scroll Container
 * @type {IdsScrollContainer}
 * @inherits IdsElement
 */
@customElement('ids-scroll-container')
@scss(styles)
export default class IdsScrollContainer extends IdsElement {
  constructor() {
    super();
  }

  static get attributes() {
    return [
      ...super.attributes,
      attributes.HEIGHT,
      attributes.WIDTH
    ];
  }

  template(): string {
    return `<slot></slot>`;
  }

  /**
   * Set the height of the element
   * @param {string | null} value The height value (e.g. '100px', '50%')
   */
  set height(value: string | null) {
    if (value) {
      this.setAttribute(attributes.HEIGHT, value);
      this.style.height = value;
    } else {
      this.removeAttribute(attributes.HEIGHT);
      this.style.height = '';
    }
  }

  /**
   * Get the current height
   * @returns {string | null} The height value
   */
  get height(): string | null {
    return this.getAttribute(attributes.HEIGHT);
  }

  /**
   * Set the width of the element
   * @param {string | null} value The width value (e.g. '200px', '100%')
   */
  set width(value: string | null) {
    if (value) {
      this.setAttribute(attributes.WIDTH, value);
      this.style.width = value;
    } else {
      this.removeAttribute(attributes.WIDTH);
      this.style.width = '';
    }
  }

  /**
   * Get the current width
   * @returns {string | null} The width value
   */
  get width(): string | null {
    return this.getAttribute(attributes.WIDTH);
  }
}
